__turbopack_context__.v({
  "TextArea": "TextArea-module-scss-module__rAJt1W__TextArea",
});
